import {InjectionToken} from '@angular/core'
import {FormValidatorConfig} from "@core/libs";

export const FORM_VALIDATOR_CONFIGURATION = new InjectionToken<FormValidatorConfig>('Ngx form validator configuration')
